// extracted by mini-css-extract-plugin
export default {"mainCard":"ManageAppoinment_mainCard__Pkhd+","textManage":"ManageAppoinment_textManage__x45cG","icon":"ManageAppoinment_icon__2zRPI","divIcon":"ManageAppoinment_divIcon__RDCk1"};